import { Controller, FieldPath, FieldValues, UseFormReturn } from "react-hook-form";
import DescriptionField from "./DescriptionField";

type Props<TFieldValues extends FieldValues, TTransformedValues extends FieldValues> = {
  form: UseFormReturn<TFieldValues, unknown, TTransformedValues>;
  name: FieldPath<TFieldValues>;
  label?: string;
  isAiGenerated?: boolean;
  readOnly?: boolean;
}

export default function DescriptionFieldOk<TFieldValues extends FieldValues, TTransformedValues extends FieldValues>(props: Props<TFieldValues, TTransformedValues>) {
  return (
    <Controller
      name={props.name}
      control={props.form.control}
      render={({ field }) => (
        <DescriptionField
          value={field.value}
          onChange={field.onChange}
          label={props.label}
          isAiGenerated={props.isAiGenerated}
          readOnly={props.readOnly}
        />
      )}
    />
  );
}
